module.exports = __webpack_public_path__ + "static/media/procedureChi.d3e165e5.png";